var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('feedback-analytics-overview',{attrs:{"feedback-data":_vm.feedbackPieChartData}}),_c('feedback-analytics-pie',{staticClass:"mt-base",attrs:{"series-data":_vm.feedbackPieChartData}}),_c('feedback-analytics-table',{staticClass:"mt-base",attrs:{"hide-updated-at-column":"","hide-actions-column":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }